function isValidHtml(description, allowedTags) {
    const regex = /<\/?([a-zA-Z0-9]+)[^>]*>/g;
    let match;
    while ((match = regex.exec(description)) !== null) {
        let tag = match[1].toLowerCase();
        if (!allowedTags.includes(tag)) {
            return false;
        }
    }
    return true;
}

function validateAndReturnHtml(description, allowedTags) {
    return isValidHtml(description, allowedTags) ? description : "";
}

function validateAndReturnComments(comments) {
    const COMMENTS_ALLOWED_TAGS = ["br", "a", "b"];
    return validateAndReturnHtml(comments, COMMENTS_ALLOWED_TAGS);
}

function validateAndReturnDescription(description) {
    const DESCRIPTION_ALLOWED_TAGS = ["p", "b", "li", "ul", "br", "i"];
    return validateAndReturnHtml(description, DESCRIPTION_ALLOWED_TAGS);
}

export {
validateAndReturnComments, validateAndReturnDescription
};


